export class  ModalKendo{
  public window: any;

  fecheModal(dados: any = null){
    this.window.close(dados);
  }
}
